import { useSpedAssessmentReopen } from '@/core/domain/sped/sped-assessment/sped-assessment.hooks';
import { useSpedDocumentContext } from '@/pages/FiscalPages/SpedPage/SpedDocumentsPage/SpedDocumentDetailPage';
import { Button, Modal } from 'antd';

export default function SpeedDocumentReopen() {
  const spedDocument = useSpedDocumentContext();

  const reopen = useSpedAssessmentReopen();

  const handleSubmit = async () => {
    try {
      if (!spedDocument) return;

      await reopen.mutateAsync(spedDocument.id);
    } catch {}
  };

  const reopenConfirm = () => {
    Modal.confirm({
      title: 'Reabrir Documento SPED',
      content: (
        <>
          <p>
            Tem certeza que deseja solicitar a reabertura do documento SPED?
          </p>
          <p>
            <strong>Esta ação pode demorar 1 minuto</strong>
          </p>
        </>
      ),
      onOk: handleSubmit,
      okText: 'Reabrir',
    });
  };

  return (
    <Button type="primary" onClick={reopenConfirm}>
      Reabrir
    </Button>
  );
}
